import { OptionType } from "../../../../utils"

export interface M024Details {
    id?: string
    date?: string
}

export interface AttachmentM024DTO {
    id?: string
    code: number
    attachmentName: string
    protocolDetailIds: string[]
}

export interface M024DetailDTO {
    id: string
    customerId: string
    entryProtocolId: string
    entryProtocolDescription: string
    entryProtocolAttachmentId: string
    fileId: string | null
    conformityEvaluation: boolean | null
    riesameEvaluation: boolean | null
    note?: string
}

export interface M024OtherDetailDTO {
    id: string
    customerId: string
    entryProtocolId: string
    entryProtocolDescription: string
    otherAttachmentId: string
    fileId: string | null
    conformityEvaluation: boolean | null
    note?: string
}

export interface M024DetailBulkConfUpdateDTO {
    id: string
    m024RowDetailsUpdateDTO: M024DetailUpdateDTO
}

export interface M024DetailUpdateDTO {
    conformityEvaluation?: boolean
    note?: string
}

export interface M024CreationOptionsDTO {
    creationDate?: Date
    userCreation?: string
    typeM024?: string
}

export interface M024CopyPrevDTO {
    idPrev?: string
    idAct?: string
}

export interface M024UpdateOptionsDTO {
    creationDate?: Date
    issueDate?: Date
    nopDetails?: string
    certificationDocumentM029?: boolean
    certificationDocumentM014?: boolean
    certificationDocumentM020?: boolean
    certificationDocumentM021?: boolean
    certificationDocumentNop?: boolean
    certificationDocumentM023?: boolean
    certificationDocumentNaqs?: boolean
    requestCertProtocol?: string
    reasonsEmissionM029Rev?: boolean
    reasonsEmissioNot?: boolean
    reasonsEmissionPsr?: boolean
    reasonsEmissionM029Request?: boolean
    otherReason?: string
    admConformity?: string
    admRegularityProtocol?: string
    closed?: boolean
    cancelRev?: boolean
    details?: M024DetailBulkConfUpdateDTO[]
}

export interface M024ResponseOptionsDTO {
    id?: string
    creationDate?: Date
    issueDate?: Date
    nopDetails?: string
    certificationDocumentM029?: boolean
    certificationDocumentM014?: boolean
    certificationDocumentM020?: boolean
    certificationDocumentM021?: boolean
    certificationDocumentNop?: boolean
    certificationDocumentM023?: boolean
    certificationDocumentNaqs?: boolean
    requestCertProtocol?: string
    reasonsEmissionM029Rev?: boolean
    reasonsEmissioNot?: boolean
    reasonsEmissionPsr?: boolean
    reasonsEmissionM029Request?: boolean
    otherReason?: string
    admConformity?: string
    admRegularityProtocol?: string
}

export enum ConformityEnum {
    SI = 'SI',
    NO = 'NO',
    NA = 'NA',
}